export const ProclamationUrl = {
  // Proclamation
  // get all list
  GetAll: '/PreReserve/ProclamationQuery/GetAllProclamations',
  // get  by id
  GetById: '/PreReserve/ProclamationQuery/GetProclamationById',
  // create
  CreateProclamation: '/PreReserve/ProclamationCommand/ProclamationCreate',
  // update
  UpdateProclamation: '/PreReserve/ProclamationCommand/ProclamationUpdate',
}

// Pricing
export const PricingUrl = {
  // get all age grouping
  GetAll: '/PreReserve/AgeGroupPricingQuery/GetAllAgeGroupPricings',
  // get age grouping by id
  GetPricingById: '/PreReserve/AgeGroupPricingQuery/GetAgeGroupPricingById',
  // get age grouping by id
  GetByProclamationId: '/PreReserve/AgeGroupPricingQuery/GetAgeGroupPricingByProclamationId',
  // create
  CreatePricing: '/PreReserve/AgeGroupPricingCommand/AgeGroupPricingCreate',
  // update
  UpdatePricing: '/PreReserve/AgeGroupPricingCommand/AgeGroupPricingUpdate',
}
